export { getWxworkMediaUrl } from './getWxInfo';
